class OperationCategoryData {
    static data() {
        return {
            1: {id: 1, name: "Покупка а/м"},
            2: {id: 2, name: "Продажа а/м"},
            3: {id: 3, name: "Перемещение а/м"}, //+
            4: {id: 4, name: "Поступление ДС"},
            5: {id: 5, name: "Возврат ДС"}, //+
            6: {id: 6, name: "Аренда"},
            7: {id: 7, name: "Брокер"},
            // 8: {id: 8, name: "Транзит ДС"},
            9: {id: 9, name: "Инкассация"},
            10: {id: 10, name: "Запчасти"}, //+
            11: {id: 11, name: "Доп оборудование"},
            12: {id: 12, name: "Зарплата"},
            13: {id: 13, name: "Коммуналка"},
            14: {id: 14, name: "Налоги"}, //+
            15: {id: 15, name: "Офис"},
            16: {id: 16, name: "Оформление"}, //+
            17: {id: 17, name: "Предпродажка"}, //+
            18: {id: 18, name: "Реклама"}, //+
            19: {id: 19, name: "Страхование"}, //+
            20: {id: 20, name: "Связь"},
            21: {id: 21, name: "Транспорт"},
            22: {id: 22, name: "Юридические услуги"}, //+
            23: {id: 23, name: "Шапка"},
            24: {id: 24, name: "Мойка"}, //+
            25: {id: 25, name: "Командировочные"},
            26: {id: 26, name: "Химчистка"}, //+
            27: {id: 27, name: "Скидка"},
            28: {id: 28, name: "От банка за авто"},
            29: {id: 29, name: "Взятие на комиссию а/м"},
            30: {id: 30, name: "Комиссия банка"}, //+
            31: {id: 31, name: "Ремонт"}, //+
            32: {id: 32, name: "Штрафы"}, //+
            33: {id: 33, name: "Процент по экв"}, //+
            34: {id: 34, name: "Прочее"}, //+
        };
    }
    static dataAsArray() {
        let arr = [];
        let data = this.data();
        for (let item in data) {
            arr.push(data[item])
        }
        return arr;
    }
    static getById(id) {
        let f = this.data()[id];
        if (f) return f;
        return null;
    }
    static forSelect() {
        return this.dataAsArray().map(function (item) {
            return {id: item.id, text: item.name};
        })
    }

    static onlyFor(balance, direction) {
        switch (balance) {
            case "cars":
                switch (direction) {
                    case "active": return _.filter(this.data(), (o) => { return [1, 29].indexOf(o.id) !== -1})
                    case "passive": return _.filter(this.data(), (o) => { return [2].indexOf(o.id) !== -1})
                }
            case "bank":
                switch (direction) {
                    case "active": return _.filter(this.data(), (o) => { return [1, 2, 3, 4, 6, 7, 9, 10, 11, 16, 17, 18, 19, 21, 22, 23, 24, 25, 26, 28,].indexOf(o.id) !== -1})
                    case "passive": return _.filter(this.data(), (o) => { return [1, 2, 3, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 30, 31, 32, 33, 34].indexOf(o.id) !== -1})
                }
            case "cash":
                switch (direction) {
                    case "active": return _.filter(this.data(), (o) => { return [1, 2, 3, 4, 6, 7, 9, 10, 11, 16, 17, 18, 19, 21, 22, 23, 24, 25, 26,].indexOf(o.id) !== -1})
                    case "passive": return _.filter(this.data(), (o) => { return [1, 2, 3, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 30, 31, 32, 34].indexOf(o.id) !== -1})
                }
            case "virtual_by_car":
                switch (direction) {
                    case "active": return _.filter(this.data(), (o) => { return false})
                    case "passive": return _.filter(this.data(), (o) => { return [7, 11, 14, 16, 17, 21, 22, 23, 30].indexOf(o.id) !== -1})
                }
        }
        return [];
    }
}

export default OperationCategoryData;
